import React from 'react';
import Helmet from 'react-helmet';
import PageLayout from '../../components/PageLayout';
import styles from './speakers.module.scss';
import Speaker from './Speaker/Speaker';

function sortSpeakers(a, b) {
  if(a.frontmatter.weight === b.frontmatter.weight) {
    if(a.frontmatter.title < b.frontmatter.title) return -1;
    if(a.frontmatter.title > b.frontmatter.title) return 1;
    return 0;
  }
  if(a.frontmatter.weight < b.frontmatter.weight) return 1;
  return -1;
}

const Speakers = (props) => {
  const speakers = props.data.allMarkdownRemark.edges.map(edge => edge.node);

  return (
  <PageLayout location={props.location}>
    <Helmet>
      <title>Speakers</title>
      <meta property="og:title" content="Featured Speakers at Marxism 2020" />
    </Helmet>
    <div className={styles.content}>
    <h1>Featured Speakers</h1>
    <div className={styles.speakers}>
      { speakers.sort(sortSpeakers).map(speaker =>
        <Speaker
          name={speaker.frontmatter.title}
          profileImage={speaker.frontmatter.profileImage}
          country={speaker.frontmatter.country}
          path={speaker.fields.path}
          key={speaker.frontmatter.title}
          className={styles.speaker}
        />
      )}
      </div>
      <div className={styles.more}>
        Plus many more!
      </div>
      </div>
  </PageLayout>
  );
};

export default Speakers;

export const pageQuery = graphql`
  query GetAllSpeakers {
    allMarkdownRemark(filter: { frontmatter: { layout: { eq: "speaker"} }}) {
      edges {
        node {
          frontmatter {
            title,
            country,
            profileImage,
            weight,
          }
          fields {
            path
          }
        }
      }
    }
  }
`;